'use client';

export const ROUTE_SCROLL_RESTORED_EVENT = 'zl-route-scroll-restored';

export interface RouteScrollRestoredState {
  pathname: string | null;
  sequence: number;
}

declare global {
  interface Window {
    __zlRouteScrollRestoredState?: RouteScrollRestoredState;
  }
}

export const getRouteScrollRestoredState = () => {
  if (typeof window === 'undefined') return null;

  return window.__zlRouteScrollRestoredState || null;
};

export const notifyRouteScrollRestored = (pathname: string | null) => {
  if (typeof window === 'undefined') return null;

  const sequence = (window.__zlRouteScrollRestoredState?.sequence || 0) + 1;
  const state: RouteScrollRestoredState = {
    pathname,
    sequence,
  };

  window.__zlRouteScrollRestoredState = state;
  window.dispatchEvent(
    new CustomEvent<RouteScrollRestoredState>(ROUTE_SCROLL_RESTORED_EVENT, {
      detail: state,
    }),
  );

  return state;
};
